<template>
  <section v-if="record.currency === 'USDT'" class="finance-order-snapshot">
    <h3>费用与到账</h3>
    <dl>
      <div><dt>方式 / 网络</dt><dd>{{ record.paymentMethodName || 'USDT' }} / {{ record.protocol || '未记录' }}</dd></div>
      <div><dt>下单汇率</dt><dd>{{ known ? `1 USDT = ${formatExchangeRate(record.exchangeRate)} CNY` : '历史未记录' }}</dd></div>
      <div><dt>{{ withdrawal ? '钱包扣款' : '折合金额' }}</dt><dd>{{ money(withdrawal ? record.debitAmount : record.settlementAmount, 'CNY') }}</dd></div>
      <div><dt>手续费</dt><dd>{{ money(record.feeAmount, withdrawal ? 'USDT' : record.feeCurrency || 'CNY') }}</dd></div>
      <div v-if="withdrawal"><dt>{{ Number(record.status) === 5 ? '实际到账' : [3, 6, 7].includes(Number(record.status)) ? '原预计到账（未到账）' : '预计到账' }}</dt><dd>{{ money(record.expectedAmount ?? record.actualAmount, 'USDT') }}</dd></div>
      <div v-else-if="Number(record.status) === 2"><dt>实际入账</dt><dd>{{ money(record.creditAmount, record.creditCurrency || 'CNY') }}</dd></div>
    </dl>
  </section>
</template>
<script setup>
import { computed } from 'vue';
import formatExchangeRate from '../utils/formatExchangeRate.js';
const props = defineProps({ record: { type: Object, required: true }, withdrawal: Boolean });
const known = computed(() => Number(props.record.exchangeRate) > 0);
const money = (value, currency) => !known.value ? '历史未记录' : value == null || value === '' ? '未记录' : `${formatExchangeRate(value)} ${currency}`;
</script>
<style scoped>
.finance-order-snapshot { padding:12px; border-radius:10px; background:#f7faff; font-size:13px; }
.finance-order-snapshot h3 { margin:0 0 8px; color:#405873; font-size:12px; font-weight:600; }
.finance-order-snapshot dl { display:grid; gap:6px; margin:0; }
.finance-order-snapshot dl > div { display:flex; justify-content:space-between; gap:16px; line-height:1.5; }
.finance-order-snapshot dt { color: #697386; }
.finance-order-snapshot dd { margin: 0; text-align: right; overflow-wrap:anywhere; min-width:0; }
</style>
